module.exports = __webpack_public_path__ + "img/warning-img01.95c6e0dc.png";